<template>
  <div id="home" class="hotel_container">
    <loading :loading="wholeLoading" />
    <div class="hotel_container_panel">
      <div :style="{'position': (this.objBaseInfo.channelId==='MOBILE' ? 'sticky':'unset')}" style="top: 0;z-index: 100;background-color: rgb(241 243 245);padding: 10px 0;">
        <Carousel :adsType="adsType"></Carousel>
        <result-search ref="search" 
          :isResultView="true" 
          :searchInfo="searchInfo" 
          @fromSearch="getcityInfo" 
          @locationInfo="locationInfo" 
          @hotelInfo="hotelInfo" 
          :pageCount="pageCount" 
          @changeCurrency="handleCurrencyChange" 
          @gomap="toMapHotelList" 
          :keywordInput="keywordInput"
          :PositionCityCode="positionCityCode"
          @clearPositionCityCode="positionCityCode = ''"></result-search>
        <!-- 位置web端 -->
        <el-row v-if="this.objBaseInfo.channelId == 'WEB'">
          <el-col :span="24">
            <div class="grid-content content_size">
              <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 5rem; line-height: 5rem">
                <el-breadcrumb-item :to="{ name: 'Home', query: this.$store.state.pathQuery }">{{
                    $t("RESULT.SEARCHHOTEL")
                  }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{
                    $t("RESULT.LISTSEARCHHOTEL")
                  }}
                </el-breadcrumb-item>
              </el-breadcrumb>
              <el-row class="location_area_bg">
                <loading :loading="loading" :isRelativeBrowserWin="false" />
                <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                  <div class="grid-content">
                    <span class="fontstyle" style="color: #979da2">{{
                        $t("RESULT.LOCATION")
                      }}</span>
                  </div>
                </el-col>
                <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
                  <div class="grid-content">
                    <!-- tab area"  -->
                    <el-tabs element-loading-background="rgba(151.157162,0.8)" v-model="activeName" @tab-click="locationAdd" class="homeMain deleteBorder">
                      <el-tab-pane v-if="objBaseInfo.destinationType=='D'" :label="$t('RESULT.DISTRICT')" name="first" :class="{ tag_height: isActive }">
                        <template v-for="item in locationInformation">
                          <el-tag v-if="item.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" class="icon_tags" disable-transitions @click="addChosentags(item,true)" type="info" :key="item.locationCode" effect="plain">
                            {{ item.locationNameLists[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                          </el-tag>
                        </template>
                      </el-tab-pane>
                      <el-tab-pane v-if="haveAirports" :label="$t('RESULT.AIRORTRAIWAY')" name="second" :class="{ tag_height: isActive }">
                        <template v-for="name in airportslocationInfo">
                          <el-tag v-if="name.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" disable-transitions @click="addChosentags(name,true)" class="icon_tags" type="info" :key="name.value" effect="plain">
                            {{ name.locationNameLists[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                          </el-tag>
                        </template>
                      </el-tab-pane>
                      <el-tab-pane v-if="haveCustoms" :label="$t('RESULT.CUSTOM')" name="third" :class="{ tag_height: isActive }">
                        <template v-for="custom in customlocationInfo">
                          <el-tag v-if="custom.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" disable-transitions @click="addChosentags(custom,true)" class="icon_tags" type="info" :key="custom.value" effect="plain">
                            {{ custom.locationNameLists[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                          </el-tag>
                        </template>
                      </el-tab-pane>
                      <div style="cursor: pointer; font-size: 2rem" @click="expand()">
                        <i class="el-icon-caret-bottom" v-show="showArrow" aria-hidden="true"></i>
                        <i class="el-icon-caret-top" v-show="showArrowDown" aria-hidden="true"></i>
                      </div>
                    </el-tabs>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="grid-content content_size" v-if="showHotHotel">
              <el-row class="location_area_bg">
                <loading :loading="loading" :isRelativeBrowserWin="false" />
                <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                  <div class="grid-content">
                    <span class="fontstyle" style="color: #979da2">{{$t("RESULT.HOTHOTEL")}}</span>
                  </div>
                </el-col>
                <el-col :xs="21" :sm="21" :md="21" :lg="21" :xl="21">
                  <div class="grid-content">
                    <!-- tab area"  -->
                    <el-tabs element-loading-background="rgba(151.157162,0.8)" v-model="activeName" class="homeMain deleteBorder">
                        <template v-for="item in hotHotelInfo">
                          <el-tag v-if="item.hotelName[$t('RESULT.RESPONSEDATA.locationNameLists')]" class="icon_tags" disable-transitions @click="choseHotHotel(item)" type="info" :key="item.hotelCode" effect="plain">
                            {{ item.hotelName[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                          </el-tag>
                        </template>
                    </el-tabs>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="content_size" style="margin-top: 1.3rem">
              <span class="fontstyle">{{ $t("RESULT.TOTAL") }} {{ this.bjtx_count }}</span>
              <span class="fontstyle" style="margin-left: 0.5rem">{{ $t("RESULT.HOTELSFOUND") }}</span>
              <el-tag disable-transitions @close="handleClose(tag)" class="fontstyle tag_sty" v-for="tag in chosentags" :key="tag.name" closable type="info">
                {{ tag[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
              </el-tag>
            </div>
          </el-col>
        </el-row>
        <!-- 星级价格排序 web端-->
        <el-row class="content_size1 content_bg" style="display: flex;justify-content:space-between" v-if="this.objBaseInfo.channelId == 'WEB'">
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" class="sort_nav">
            <div class="grid-content center_style" tabindex="0" role="button">
              <span class="commen_font" @click="ptOpenDowOrUp('price')">{{ $t("RESULT.PRICE") }}</span>
              <el-icon v-if="show ==3" class="red_color" title="Minus"><Minus /></el-icon>
              <el-icon v-if="show ==1" class="red_color" title="Ascending"><SortUp /></el-icon>
              <el-icon v-if="show ==2" class="red_color" title="Descending"><SortDown /></el-icon>
            </div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
            <div class="grid-content center_style">
              <el-select class="payment payment-price-range" v-model="priceAreaValue" :placeholder="$t('RESULT.PRICERANGE')">
                <el-option v-for="item in priceRangeOptions" :key="item.value" :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.value" @click="handlePriceRangeChange(item.value)">
                </el-option>
                <!-- <div class="el-select-dropdown__item" @click="ptOpenCustomizePrice">
                  <svg-icon></svg-icon>
                  <span>自定义</span>
                </div> -->
              </el-select>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" style="margin-left: 1rem;" class="sort_nav">
            <div class="grid-content center_style" tabindex="0" role="button">
              <span class="commen_font" @click="ptOpenDowOrUp('star')">{{ $t("RESULT.STARRATING") }}</span>
              <el-icon v-if="showstar ==3" class="red_color" title="Minus"><Minus /></el-icon>
              <el-icon v-if="showstar ==1" class="red_color" title="Ascending"><SortUp /></el-icon>
              <el-icon v-if="showstar ==2" class="red_color" title="Descending"><SortDown /></el-icon>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" style="margin-right: 2rem;">
            <div class="grid-content center_style">
              <el-select class="payment payment-star" v-model="starSelect" :placeholder="computedPlaceholder" clearable multiple @visible-change ="handleStarChange" @clear="handlePaymentChange" @remove-tag="handlePaymentChange">
                <el-option v-for="item in this.starOption" :key="item.value" :label="item.text" :value="item.value || ''">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3" style="margin-right: 2rem;">
            <div class="grid-content center_style">
              <el-select class="payment payment-hotel-group" v-model="hotelGroupSelect" :placeholder="$t('BOOKING.HOTELGROUP')" clearable filterable  @change ="getHotelData" @clear="handlePaymentChange">
                <el-option v-for="item in this.hotelGroupOption" :key="item.value" :label="item.label" :value="item.value || ''">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" style="margin-right: 2rem;" v-if="showDistance || objBaseInfo.destinationType === 'I'">
            <div class="grid-content center_style">
              <el-select class="payment payment-distance" v-model="value" :placeholder="$t('RESULT.DISTANCE')" @change="distanceChange()">
                <el-option v-for="item in disOptions" :key="item.value" :label="item.label[$t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')]" :value="item.value || ''">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3" style="margin-right: 2rem;">
            <div class="grid-content center_style">
              <el-select class="payment payment-type" v-model="paymentType" :placeholder="$t('RESULT.PAYMENT')" clearable @change="handlePaymentChange">
                <el-option v-for="item in this.getPaymentOption" :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2" v-if="objBaseInfo.destinationType === 'I' || objBaseInfo.isGATCity">
            <div class="grid-content center_style">
              <el-select class="payment payment-currency" v-model="currencyType.code" :placeholder="$t('RESULT.CURRENCY')" clearable @change="handleCurrencyChange">
                <el-option v-for="item in this.currencyOpt" :key="item.value" :label="item.label" :value="item.value || ''">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" style="float: right">
            <div class="grid-content center_style" style="float: right; margin-right: 1rem" v-show="this.objBaseInfo.channelId == 'WEB'">
              <svg-icon icon="location" icon-class="location" class="showmap_icon_style"></svg-icon>
              <span class="showmap" @click="toMap()">{{ $t("RESULT.SHOWONMAP") }}
              </span>
            </div>
          </el-col>
        </el-row>
        <el-row class="content_size1 content_bg" style="display: flex;justify-content:space-between" v-if="this.$objBaseInfo.channelId == 'WEB' && this.$objBaseInfo.sourceType === 'CRM'">
          <el-col>
            <span class="commen_font">traceid: {{traceid}}</span>
          </el-col>
        </el-row>
        <!-- 移动端下拉菜单 -->
        <van-dropdown-menu v-if="this.objBaseInfo.channelId == 'MOBILE'">
          <!-- 星级价格排序 -->
          <van-dropdown-item v-model="sortValue" :options="priceStarOption" />
          <!-- 支付方式 -->
          <van-dropdown-item v-model="dropValue" :options="paymentOption" />
          <!-- 价格范围 -->
          <van-dropdown-item v-model="priceRangeValue" :options="priceRangeOption" :title="priceRangeTitle" @closed="priceRangeClose(priceRangeValue)"/>
          <!-- 筛选 -->
          <van-dropdown-item :title="$t('RESULT.MOBILELOCATION')" ref="location" :title-class="titleActive" @open="distMenuOpen">
            <van-tree-select height="66vw" :items="treeSelect" v-model:main-active-index="treeActive">
              <template #content>
                <div style="margin: 1rem" v-if="(treeActive == 1 || treeActive == 2)">
                  <p class="dist-title">{{ $t("RESULT.DISTANCE") }}</p>
                  <van-tag
                    v-for="dis in disOptions"
                    :key="dis.value"
                    type="primary"
                    size="large"
                    plain
                    :class="{ 'click-dist-tag': dis.value == distSelected }"
                    @click="distClick(dis.value)"
                  >{{ dis.label[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")] }}</van-tag>
                </div>
                
                <div v-if="treeActive == 0">
                  <van-radio-group v-model="areaRadio">
                    <van-cell-group>
                      <van-cell v-for="item in locationInformation" :key="item.locationCode" :title="item.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" clickable @click="areaChange(item)">
                        <template #right-icon>
                          <van-radio :name="item.locationCode" />
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </div>
                
                <div style="margin: 1rem" v-if="treeActive == 1">
                  <p class="dist-title">{{ $t("RESULT.AIRORTRAIWAY") }}</p>
                  <span v-for="way in airportslocationInfo" :key="way.locationCode">
                    <van-tag
                      v-if="way.locationNameLists && way.locationNameLists.en"
                      type="primary"
                      size="large"
                      plain
                      :class="{ 'click-dist-tag': way.locationCode == waySelected }"
                      @click="wayClick(way)"
                    >{{ way.locationNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")] }}</van-tag>
                  </span>
                </div>
                
                <div style="margin: 1rem" v-if="treeActive == 2">
                  <p class="dist-title">{{ $t("RESULT.CUSTOM") }}</p>
                  <span v-for="custom in customlocationInfo" :key="custom.locationCode">
                    <van-tag
                      v-if="custom.locationNameLists && custom.locationNameLists.en"
                      type="primary"
                      size="large"
                      plain
                      :class="{
                        'click-dist-tag': custom.locationCode == customSelected,
                      }"
                      @click="customClick(custom)"
                    >{{ custom.locationNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")] }}</van-tag>
                  </span>
                </div>
                
                <div style="margin: 1rem" v-if="treeActive == 3">
                  <p class="dist-title">{{ $t("RESULT.HOTHOTEL") }}</p>
                  <span v-for="hotHotel in hotHotelInfo" :key="hotHotel.hotelCode">
                    <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': hotHotel.hotelCode == hotHotelSelected,}" @click="hotHotelClick(hotHotel)">
                      {{ hotHotel.hotelName[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                    </van-tag>
                  </span>
                </div>
                <div style="margin: 1rem" v-if="treeActive == 5">
                  <span v-for="item in starOption" :key="item.value">
                    <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': h5StarSelect.includes(item.value),}" @click="starClick(item)">
                      {{ item.text }}
                    </van-tag>
                  </span>
                </div>
                <div style="margin: 1rem" v-if="treeActive == 4">
                  <span v-for="item in hotelGroupOption" :key="item.value">
                    <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': item.value == hotelGroupSelect,}" @click="hotelGroupClick(item)">
                      {{ item.label }}
                    </van-tag>
                  </span>
                </div>
              </template>
            </van-tree-select>
            <div style="padding: 0.5rem 1.6rem;">
              <van-button type="danger" class="top-vant-btn" block round @click="onTreeReset">
                {{ $t("MESSAGE.RESETBTN") }}
              </van-button>
              <van-button type="danger" class="top-vant-btn" block round @click="onTreeConfirm">
                {{ $t("MESSAGE.CONFIRMBTN") }}
              </van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <!-- content -->
      <ResultContent v-if="!showMapResult"></ResultContent>
      <MapResultContent v-if="showMapResult"></MapResultContent>
    </div>
    <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" :icon="confirmIcon" @setConfirmFlag="setConfirmFlag"></ConfirmBoxs>
    <!-- <div class="map_btn" v-if="this.objBaseInfo.channelId === 'MOBILE'"><el-button type="primary" icon="el-icon-s-promotion" @click="toMapHotelList()"> {{ $t("RESULT.MAP") }}</el-button></div> -->
    <el-dialog v-model="showCustomizePriceRange" width="35rem" center :title="$t('RESULT.PRICERANGE')" customClass="customWidth" :close-on-click-modal="false">
      <div class="form">
        <el-row type="flex" justify="center" align="middle">
          <el-col :xs="12" :lg="6">
            <el-input size="small" v-model="priceRangeFrom" @input="clearNoNumPriceRangeFrom()"></el-input>
          </el-col>
          <el-col :xs="12" :lg="2" style="text-align: center;" >
            <el-icon><Minus /></el-icon>
          </el-col>
          <el-col :xs="12" :lg="6">
            <el-input size="small" v-model="priceRangeTo" @input="clearNoNumPriceRangeTo()" ></el-input>
          </el-col>
        </el-row>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <button class="s_btn btn_dialog" @click="searchHotelForPriceRange()">{{ $t("MESSAGE.CONFIRMBUTTONTEXT") }}</button>
          <button class="dialog_btn_n btn_dialog" @click="showCustomizePriceRange = false">{{ $t("MESSAGE.CONFIRMCANCELTEXT") }}</button>
        </span>
      </template>
    </el-dialog>
    <EjectAnnouncement :centerDialogVisible="hotelListNoticeDialogVisible" @setAnnouncementFlag="setAnnouncementFlag"></EjectAnnouncement>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue';
import ResultSearch from "../../components/ResultSearch.vue";
import { locationList, availabilityArea,getAnnouncementInfo,getcountryList } from "@/api/shoppingData";
import { formatDateTime, hideElement, isCityGAT,getCityInfoByCode } from "@/utils/utils.js";
import Loading from "@/components/Loading.vue";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import Carousel from "../../components/Carousel.vue";
import { gethothotel } from "@/api/bookingData.js";
import EjectAnnouncement from "../../components/EjectAnnouncement.vue";
import ResultContent from "../resultPage/ResultContent.vue";
import MapResultContent from "../resultPage/MapResultContent.vue";
import { Minus, SortUp, SortDown } from "@element-plus/icons-vue";
import { showToast } from "vant";

const ALLOWED_DETAIL_PATHS = ["/Detail", "/detail", "/sit/Detail", "/sit/detail"];

function getSafeDetailOpenUrl(rawUrl) {
  if (typeof rawUrl !== "string" || !rawUrl.trim()) {
    return "";
  }
  try {
    const parsed = new URL(rawUrl, window.location.origin);
    const isHttp = parsed.protocol === "http:" || parsed.protocol === "https:";
    const isSameOrigin = parsed.origin === window.location.origin;
    const isAllowedPath = ALLOWED_DETAIL_PATHS.includes(parsed.pathname);
    return isHttp && isSameOrigin && isAllowedPath ? parsed.toString() : "";
  } catch (e) {
    return "";
  }
}

function normalizeDetailQueryValue(value) {
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
}

function normalizeDetailQuery(query) {
  return Object.keys(query).reduce((params, key) => {
    const value = query[key];
    if (value !== undefined && value !== null) {
      params[key] = normalizeDetailQueryValue(value);
    }
    return params;
  }, {});
}

export default {
  name: "Result",
  components: {
    ResultSearch,
    Loading,
    ConfirmBoxs,
    EjectAnnouncement,
    Carousel,
    ResultContent,
    MapResultContent,
    Minus,
    SortUp,
    SortDown
  },
  provide() {
    return {
      ResultData: this,
    }
  },
  data() {
    return {
      unChoosen: false,
      checkInDate: '',
      checkOutDate: '',
      pathSource: "",
      pageCount: 1,
      canClick: true,
      haveAirports: false,
      haveCustoms: false,
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      tabName: "",
      paneHeight: "pane-first",
      scrollHeight: 0,
      tagHeight: 0,
      isActive: false,
      showArrow: false,
      showArrowDown: false,
      loading: false,
      hotelloading: false,
      wholeLoading: false,
      wholeLLoading: false,
      wholeHLoading: false,
      loadingIsFloatingLayer: false, //控制Loading样式
      noMoreData: false,
      locationInformation: [],
      airportslocationInfo: [],
      customlocationInfo: [],
      locationCode: "",
      hotelNum: "",
      locationType: 1,
      showDistance: false,
      chosentags: [],
      locations: [],
      hotelList: [],
      airports: [],
      customs: [],
      activeName: "first",
      searchInfo: {},
      cityInfo: "",
      options: [],
      value: "",
      show: 3,
      showstar: 3,
      distance: "",
      sortByPrice: null,
      sortByStarRating: null,
      havemore: false,
      bjtx_page: 1,
      bjtx_rows: 10,
      bjtx_count: "", // 总数 this.hotelList.totalNum
      disabled_x: false, // 表示是否执行回调函数触底事件
      labelLongitude: '', //经度
      labelLatitude: '', //经度
      geoCodeType: "", //经纬度类型
      coordinates: {},
      paymentType: "",
      paymentCode: "",
      //paymentTypeMethod: [],
      currencyType:{ code:""},
      currencyCode:"",
      currencyOpt:[
        { value: "0", label: "USD" },
        { value: "1", label: "EUR" },
        { value: "2", label: "CNY" }
      ],
      roomNum: 1,
      guestNum: 1,
      paymentOption: [],
      priceStarOption: [],
      sortValue: "nan1",
      dropValue: "nan2",
      treeSelect: [],
      treeActive: 0,
      areaRadio: "",
      disOptions: [
        {
          value: 1,
          label: { "zh-CN": "1公里", en: "1KM" },
        },
        {
          value: 3,
          label: { "zh-CN": "3公里", en: "3KM" },
        },
        {
          value: 5,
          label: { "zh-CN": "5公里", en: "5KM" },
        },
        {
          value: 10,
          label: { "zh-CN": "10公里", en: "10KM" },
        },
        {
          value: 30,
          label: { "zh-CN": "30公里", en: "30KM" },
        },
        {
          value: 50,
          label: { "zh-CN": "50公里", en: "50KM" },
        },
        {
          value: 100,
          label: { "zh-CN": "100公里", en: "100KM" },
        },
      ],
      distSelected: null,
      waySelected: "",
      customSelected: "",
      choseArea: {},
      choseWay: {},
      choseCustom: {},
      isClickBooked: false,
      isToolTip: {},
      isExecTo: true,
      isAddTags: false,
      titleActive: "", //location_active
      keywordInput: {},
      selectMenuActive: 0, //位置距离选择中的菜单
      selectLocationCode: {}, //位置距离选择中的菜单
      keywordType: "",
      priceRangeOptions:[
        {value: 1,label: { "zh-CN": "不限", en: "unlimited" },},
        {value: 2,label: { "zh-CN": "0-300", en: "0-300" },},
        {value: 3,label: { "zh-CN": "300-500", en: "300-500" },},
        {value: 4,label: { "zh-CN": "500-1000", en: "500-1000" },},
        {value: 5,label: { "zh-CN": "1000以上", en: "From 1000" },},
        {value: 6,label: { "zh-CN": "自定义", en: "customize" },},
      ],
      priceRangeValue: 0,
      priceRangeOption:[],
      priceArea: "",
      priceAreaValue:"",
      showCustomizePriceRange: false,
      priceRangeFrom: "",
      priceRangeTo: "",
      priceRangeTitle: this.$t("RESULT.PRICERANGE"),
      hotelListNoticeDialogVisible: false,
      noticeTitle:"",
      showHotelListNotice: false,
      hotHotelInfo: [],
      showHotHotel: false,
      hotHotelSelected: "",
      chosehotHote:{},
      isCityChange: false,
      adsType:3,
      isCorpPay: false,
      isHotelPay: false,
      isPrepay:false,
      wifiList:["FCT01205"],
      starOption:[],
      starSelect:"",
      originalStarSelect:"",
      h5StarSelect:[],
      centerPointHotelId:"",
      hotelGroupOption:[],
      hotelGroupSelect:"",
      showMapResult:false,
      mapSearch:false,
      address: "",
      returnParent: "",
      isExecuting: false,
      isBackFromDetail: false,
      positionCityCode: "",
      traceid:"",
      objBaseInfo: {},
    };
  },
  created() {
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
    }
    this.searchInfo = JSON.parse(this.$route.query.searchParam);
    this.restoreFromSessionStorage();
    this.centerPointHotelId = this.searchInfo.centerPointHotelId;
    this.adsType = this.objBaseInfo.destinationType == "D" ? 3 : 4;
    this.activeName = this.objBaseInfo.destinationType == "D" ? "first" : "second";
    this.pathSource = this.objBaseInfo.sourceType ? this.objBaseInfo.sourceType : "";
    this.pageCount = this.objBaseInfo.maximumNumberProperties;
    if (this.$route.query.searchParam) {
      try {
        this.searchInfo = JSON.parse(this.$route.query.searchParam)
      } catch (e) {
        this.searchInfo = {} // 解析失败时设置为默认值
      }
    }
  },
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素 "MOBILE"、"WEB"
    hideElement(this);
    if(this.$objBaseInfo.sourceType === "CRM"){
      this.getCityName();
      this.getCountryList(this.searchInfo.city.cityInfo.countryCode);
    }
    this.showDistance = true;
    this.options = this.getDisList;
    this.setPriceAffix();
    this.roomNum = this.searchInfo.roomCount;
    this.guestNum = this.searchInfo.guestCount;
    if(this.searchInfo.showMapResult != undefined){
      this.showMapResult = this.searchInfo.showMapResult;
    }
    window.name = '';
    //滚动事件
    window.addEventListener("scroll", this.handleScroll);
    //获取payment Type Method
    // if (this.objBaseInfo.isCorpPay) {
    //   this.paymentTypeMethod = [
    //     { value: "0", label: "COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE1" },
    //     { value: "1", label: "COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3" },
    //   ];
    // } else {
    //   this.paymentTypeMethod = [
    //     { value: "0", label: "COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE1" },
    //   ];
    // }
    if(this.objBaseInfo.sourceType == "OBT"){
      this.popUpAnnouncement(sessionStorage.getItem("isFirstIntoResult") == "true");
      this.searchHotHotel();
    }
  },
  destroyed() {
    //销毁滚动事件
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    // 顶部下拉菜单 支付方式
    getPaymentOption() {
      var paymentType = [];
      if (this.isCorpPay) {
        paymentType.push(
          { value: "1", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3")});
      }
      if(this.isHotelPay){
        paymentType.push(
          { value: "0", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE1")}
        );
      }
      if(this.isPrepay){
        paymentType.push(
          { value: "2", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2")}
        );
      }
      if(this.objBaseInfo.channelId == 'MOBILE'){
        paymentType.unshift({ value: "nan2", text: this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPENAN") });
      }
      return paymentType;
    },
    // 价格星级排序
    getPriceStar() {
      return [
        { text: this.$t("RESULT.MOBILESORT"), value: "nan1" },
        { text: this.$t("RESULT.MOBILESORTPRICEHIGH"), value: "highPrice" },
        { text: this.$t("RESULT.MOBILESORTPRICELOW"), value: "lowPrice" },
        { text: this.$t("RESULT.MOBILESORTSTARHIGH"), value: "highStar" },
        { text: this.$t("RESULT.MOBILESORTSTARLOW"), value: "lowStar" },
      ];
    },
    // 位置筛选
    getTreeSelect() {
      return [
        { text: this.$t("RESULT.DISTRICT") },
        { text: this.$t("RESULT.AIRORTRAIWAY") },
        { text: this.$t("RESULT.CUSTOM") },
        { text: this.$t("RESULT.HOTHOTEL") },
        { text: this.$t("BOOKING.HOTELGROUP") },
        { text: this.$t("RESULT.STARSELECT") },
      ];
    },
    // 价格范围
    getPriceRangeSelect() {
      return [
        { text: this.$t("RESULT.PRICERANGE"), value:  0 },
        { text: this.$t("RESULT.PRICERANGE1"), value: 1 },
        { text: this.$t("RESULT.PRICERANGE2"), value: 2 },
        { text: this.$t("RESULT.PRICERANGE3"), value: 3 },
        { text: this.$t("RESULT.PRICERANGE4"), value: 4 },
        { text: this.$t("RESULT.PRICERANGE5"), value: 5 },
        { text: this.$t("RESULT.PRICERANGE6"), value: 6 },
      ];
    },
    // 星级筛选
    getStarSelect() {
      return [
        { text: this.$t("RESULT.STAR5"), value: "5" },
        { text: this.$t("RESULT.STAR4"), value: "4" },
        { text: this.$t("RESULT.STAR3"), value: "3" },
        { text: this.$t("RESULT.STAR2"), value: "2" },
        { text: this.$t("RESULT.STAR1"), value: "1" },
      ];
    },
    computedPlaceholder() {
      return this.starSelect != "" ? '' : this.$t('RESULT.STARSELECT');
    },
    getHotelGroupSelect(){
      return [
        { label: this.$t("HOTELGROUPINFO.Hyatt"), value: "12733" },
        { label: this.$t("HOTELGROUPINFO.Wyndham"), value: "12796" },
        { label: this.$t("HOTELGROUPINFO.Radisson"), value: "12766" },
        { label: this.$t("HOTELGROUPINFO.Marriott"), value: "12736" },
        { label: this.$t("HOTELGROUPINFO.Accor"), value: "12725" },
        { label: this.$t("HOTELGROUPINFO.Hilton"), value: "12737" },
        { label: this.$t("HOTELGROUPINFO.IHG"), value: "12738" },
        { label: this.$t("HOTELGROUPINFO.ShangriLa"), value: "12734" },
        { label: this.$t("HOTELGROUPINFO.Rosewood"), value: "12995" },
        { label: this.$t("HOTELGROUPINFO.Millennium"), value: "12781" },
        { label: this.$t("HOTELGROUPINFO.HUAZHU"), value: "12997" },
        { label: this.$t("HOTELGROUPINFO.Ramada"), value: "12772" },
        { label: this.$t("HOTELGROUPINFO.TheRitzCarlton"), value: "12774" },
        { label: this.$t("HOTELGROUPINFO.Raffles"), value: "12727" },
        { label: this.$t("HOTELGROUPINFO.Atour"), value: "12987" },
        { label: this.$t("HOTELGROUPINFO.JinJiangInternational"), value: "12730" },
        { label: this.$t("HOTELGROUPINFO.JinjiangChina"), value: "12976" },
        { label: this.$t("HOTELGROUPINFO.Wanda"), value: "12900" },
        { label: this.$t("HOTELGROUPINFO.Preferred"), value: "13456" },
        { label: this.$t("HOTELGROUPINFO.Ascott"), value: "12759" },
        { label: this.$t("HOTELGROUPINFO.Kempinski"), value: "12768" },
        { label: this.$t("HOTELGROUPINFO.Homeinns"), value: "12755" },
        { label: this.$t("HOTELGROUPINFO.Dossen"), value: "12815" },
        { label: this.$t("HOTELGROUPINFO.DossenInternational"), value: "13388" },
        { label: this.$t("HOTELGROUPINFO.Banyantree"), value: "12810" },
        { label: this.$t("HOTELGROUPINFO.Fraser"), value: "12960" },
        { label: this.$t("HOTELGROUPINFO.Jumeirah"), value: "13024" },
        { label: this.$t("HOTELGROUPINFO.Langham"), value: "12842" },
        { label: this.$t("HOTELGROUPINFO.MandarinOriental"), value: "12926" },
        { label: this.$t("HOTELGROUPINFO.MarcoPolo"), value: "12741" },
        { label: this.$t("HOTELGROUPINFO.NewCentury"), value: "12760" },
        { label: this.$t("HOTELGROUPINFO.SSAW"), value: "13317" }
      ];
    }
  },
  updated() {
    this.options = this.getDisList;
    this.setPriceAffix();
    this.paymentOption = this.getPaymentOption;
    this.priceStarOption = this.getPriceStar;
    this.treeSelect = this.getTreeSelect;
    this.priceRangeOption =  this.getPriceRangeSelect;
    this.starOption = this.getStarSelect;
    this.hotelGroupOption = this.getHotelGroupSelect;
  },
  watch: {
    // 排序变化
    sortValue(newVal) {
      this.sortChange(newVal);
    },
    //支付方式切换
    dropValue(newVal) {
      this.paymentChange(newVal);
    },
    //价格范围变化
    priceRangeValue(newVal) {
      this.priceRangeTitle = this.getPriceRangeSelect[newVal].text
      this.handlePriceRangeChange(newVal);
    },
    //获取酒店打标
    getHotelMarking(){
      return function(hotel) {
        let value="";
        if(hotel.hasOwnProperty("cwtMark")){
          if(hotel.cwtMark != undefined && hotel.cwtMark != null){
            let mark=hotel.cwtMark;
            if(this.$i18n.locale == "en"){
              value = mark["en"];
            }
            else{
              value = mark["zh-CN"];
            }
          }
        }
        return value;
      };
    },
    getCpHotelMark(){
      return function(item) {
        if(!item.isFixedCPHotel)
        {
          if(this.objBaseInfo.isShowChainWide){
            return this.$t("RESULT.CHAIMWIDE");
          }
          return "";
        }
        return this.$t("RESULT.CONTRACTEDHOTEL");
      };
    },
  },
  methods: {
    getCityName() {
      getCityInfoByCode(this.searchInfo.cityCode).then((city) => {
        if (city) {
          this.$objBaseInfo.gaoDeCityCode = city?.gaoDeCityCode || '';
        }
      });
    },
    getCountryList(countryCode) {
      let searchparams = {
        params: {
          countryCode: countryCode,
        },
      };
      getcountryList(searchparams)
        .then((res) => {
          if(res.code==200 && res.data.list.length > 0){
            this.$objBaseInfo.gaoDeCountryCode = res.data.list[0]?.gaoDeCountryCode || '';
          }
        });
    },
    restoreFromSessionStorage() {
      try {
        // 恢复整个组件数据
        const savedData = sessionStorage.getItem('resultData');
        if (savedData) {
          const parsedData = JSON.parse(savedData);
          Object.assign(this.$data, parsedData);
          this.searchInfo.checkInAt = parsedData.checkInDate || '';
          this.searchInfo.checkOutAt = parsedData.checkOutDate || '';
          this.searchInfo.keyword = parsedData.keywordInput.keyword || '';
          this.searchInfo.keywordType = parsedData.keywordType || '';
          this.isBackFromDetail = true;
          this.onTreeConfirm(); // 恢复数据后重新获取酒店数据
        }
      } catch (error) {
        console.error('恢复数据失败:', error);
      }
    },
    //移动端
    distMenuOpen() {
      if (this.objBaseInfo.destinationType == "I" && this.selectMenuActive == 0) {
        this.treeActive = 1;
      } else {
        this.treeActive = this.selectMenuActive;
      }
      this.$nextTick(() => {
        if (document.querySelector(".van-sidebar-item")) {
          document.querySelector(".van-sidebar-item").style.display = "none";
        }
      });
      switch (this.selectMenuActive) {
        case 0:
          this.areaRadio = this.selectLocationCode.locationCode;
          this.choseArea = this.selectLocationCode;
          break;
        case 1:
          this.waySelected = this.selectLocationCode.locationCode;
          this.choseWay = this.selectLocationCode;
          break;
        case 2:
          this.customSelected = this.selectLocationCode.locationCode;
          this.choseCustom = this.selectLocationCode;
          break;
      }
    },
    // result 通往 map 页
    toMapHotelList (){
      this.showMapResult = !this.showMapResult;
    },
    //mobile 跳转
    toMobileDetail(item) {
      if (this.objBaseInfo.channelId == "MOBILE") {
        if (item !=undefined && item.hotelDescriptiveInfo) {
          if (this.isExecTo) {
            this.toDetail(item);
          } else {
            this.isExecTo = true;
          }
        } else {
          this.isExecTo = false;
          this.isToolTip[item] = !this.isToolTip[item];
        }
      }
    },
    // 支付方式切换
    paymentChange(val) {
      if (val == "nan2") {
        this.paymentType = "";
      } else {
        this.paymentType = val;
      }
      this.getHotelData();
    },
    // 排序变化重新查询
    sortChange(type) {
      switch (type) {
        case "nan1":
          this.sortByPrice = null;
          this.sortByStarRating = null;
          break;
        case "highPrice":
          this.sortByPrice = false;
          this.sortByStarRating = null;
          break;
        case "lowPrice":
          this.sortByPrice = true;
          this.sortByStarRating = null;
          break;
        case "highStar":
          this.sortByPrice = null;
          this.sortByStarRating = false;
          break;
        case "lowStar":
          this.sortByPrice = null;
          this.sortByStarRating = true;
          break;
        default:
          this.sortByPrice = null;
          this.sortByStarRating = null;
          break;
      }
      this.getHotelData();
    },
    // 自定义坐标切换
    customClick(val) {
      this.customSelected = val.locationCode;
      this.choseCustom = val;
    },
    // 机场火车站切换
    wayClick(val) {
      this.waySelected = val.locationCode;
      this.choseWay = val;
    },
    // 距离切换
    distClick(val) {
      this.distSelected = val;
    },
    // 地区切换
    areaChange(item) {
      this.areaRadio = item.locationCode;
      this.choseArea = item;
    },
    hotHotelClick(val){
      this.hotHotelSelected = val.hotelCode;
      this.chosehotHote = val;
    },
    starClick(item){
      const index = this.h5StarSelect.indexOf(item.value);
      if (index === -1) {
        this.h5StarSelect.push(item.value);
      } else {
        this.h5StarSelect.splice(index, 1);
      }
    },
    hotelGroupClick(val){
      this.hotelGroupSelect = val.value;
      //this.chosehotHote = val;
    },
    onTreeReset() {
      this.treeActive = 0;
      this.areaRadio = "";
      this.waySelected = "";
      this.customSelected = "";
      this.hotHotelSelected = "";
      this.h5StarSelect = [];
      this.keyword = "";
      this.hotelGroupSelect = "";
      this.distSelected = null;
      this.mapSearch = false;
      delete this.searchInfo.city.cityInfo.locationName;
      delete this.searchInfo.city.cityInfo.locationCnName;
      delete this.searchInfo.city.cityInfo.locationCode;
      delete this.searchInfo.city.cityInfo.locationEnName;
      delete this.searchInfo.city.cityInfo.locationLatitude;
      delete this.searchInfo.city.cityInfo.locationLongitude;
      this.searchInfo.city.cityInfo.locationType = this.treeActive;
    },
    // 树形菜单确认按钮
    onTreeConfirm(locationInfo) {
      if (this.isExecuting) {
        return;
      }
      this.isAddTags = false;
      let locationChose = {};
      if (this.treeActive == 0) {
        // 地区切换
        this.tabName = "first";
        if (this.areaRadio) {
          locationChose = this.choseArea;
          this.isAddTags = true;
        }
        this.value = this.objBaseInfo.destinationType != 'I' ? null: 30;
        this.customSelected = this.waySelected = this.hotHotelSelected = this.starSelect = this.hotelGroupSelect = "";
        this.h5StarSelect = [];
      } else if (this.treeActive == 1) {
        //机场/火车站
        this.tabName = "second";
        if (this.waySelected) {
          locationChose = this.choseWay;
          this.isAddTags = true;
        } else {
          // 未选中机场火车站
          showToast(this.$t("RESULT.MOBILESELECTAIR"));
          return false;
        }
        this.value = this.distSelected;
        this.customSelected = this.areaRadio = this.hotHotelSelected = this.starSelect = this.hotelGroupSelect = "";
        this.h5StarSelect = [];
      } else if (this.treeActive == 2) {
        //自定义地标
        this.tabName = "third";
        if (this.customSelected) {
          locationChose = this.choseCustom;
          this.isAddTags = true;
        } else {
          showToast(this.$t("RESULT.MOBILESELECTCUSTOMER"));
          // 未选中自定义坐标
          return false;
        }
        this.value = this.distSelected;
        this.waySelected = this.areaRadio = this.hotHotelSelected = this.starSelect = this.hotelGroupSelect = "";
        this.h5StarSelect = [];
      }else if (this.treeActive == 3) {
        //热门酒店
        this.tabName = "five";
        if (this.hotHotelSelected) {
          this.keyword = this.chosehotHote.hotelName[this.$t('RESULT.RESPONSEDATA.locationNameLists')];
          this.isAddTags = true;
        } else {
          showToast(this.$t("RESULT.MOBILESELECTHOTHOTEL"));
          // 未选中热门酒店
          return false;
        }
        this.value = null;
        this.waySelected = this.areaRadio = this.customSelected = this.starSelect = this.hotelGroupSelect = "";
        this.h5StarSelect = [];
      }else if(this.treeActive == 5){
        //星级筛选
        this.tabName = "six";
        if(this.h5StarSelect.length >0){
          this.isAddTags = true;
          this.value = null;
          this.waySelected = this.areaRadio = this.customSelected = this.hotHotelSelected = this.hotelGroupSelect = "";
          this.starSelect = this.h5StarSelect;
        }
      }else if(this.treeActive == 4){
        //酒店集团
        this.tabName = "seven";
        if(this.hotelGroupSelect){
          this.isAddTags = true;
          this.value = null;
          this.waySelected = this.areaRadio = this.customSelected = this.hotHotelSelected = this.starSelect = "";
        }
      }else if(this.treeActive == 6){
        //自定义位置
        this.tabName = "eight";
        this.mapSearch = true;
      }
      this.selectMenuActive = this.treeActive == 99 ? 1 : this.treeActive;
      this.selectLocationCode = locationChose;
      if (locationChose && locationChose.locationCode) {
        this.labelLongitude = locationChose.longitude;
        this.labelLatitude = locationChose.latitude;
        this.geoCodeType = locationChose.geoCodeType;
        this.locationCode = locationChose.locationCode;
        this.keywordInput = { keyword: locationChose.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")], keywordType: "auto" };
        this.keyword = locationChose.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
        this.titleActive = "location_active";
        this.keywordType = "auto";
        this.searchInfo.city.cityInfo = {
            locationName: locationChose.locationNameLists,
            locationCnName: locationChose.locationName,
            locationCode: locationChose.locationCode,
            locationEnName: locationChose.locationNameLists.en,
            locationLatitude: locationChose.latitude,
            locationLongitude: locationChose.longitude,
            locationType: this.treeActive + 1
        };
      } else {
          if(this.treeActive != 6){
            this.keywordInput = { keyword: this.keyword, keywordType: "input" };
            this.labelLongitude = "";
            this.labelLatitude = "";
            this.geoCodeType = "";
            this.locationCode = "";
            this.selectLocationCode = {};
            this.keywordType = "input";
            if (this.treeActive === 3 || this.treeActive === 5) {
                this.titleActive = "location_active";
            } else {
                this.titleActive = "";
                this.starSelect = "";
                this.h5StarSelect = [];
            }
          }else{
            this.titleActive = "";
          }
      }
      if (this.$refs.location?.toggle) {
        this.$refs.location.toggle(false);
      }
      //landmark处理
      if (this.tabName == "four" && locationInfo) {
        this.isAddTags = true;
        this.value = 5;
        this.labelLongitude = locationInfo.longitude;
        this.labelLatitude = locationInfo.latitude;
        this.geoCodeType = locationInfo.geoCodeType;
        this.locationCode = locationInfo.locationCode;
        this.keywordInput = {keyword: locationInfo.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")], keywordType: "auto"};
      }
      if (this.searchInfo.distSelected && this.objBaseInfo.destinationType == "I") {
        this.value = this.searchInfo.distSelected
      }
      if(locationInfo){
        if(locationInfo.isTrusted){
          if(this.treeActive != 5){
            this.centerPointHotelId = '';
          }
        }else{
          this.value = this.centerPointHotelId ? 3:30;
        }
      }
      this.getHotelData();
    },
    airportGet() {
      this.locationType = 2;
      this.getLocationData(2);
    },
    customlocationGet() {
      this.locationType = 3;
      this.getLocationData(3);
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    
    height() {
      if (document.getElementById(this.paneHeight)) {
        this.scrollHeight = document.getElementById(this.paneHeight).scrollHeight;
      }
      let minHeight = 85;
      this.tagHeight = this.scrollHeight > minHeight ? minHeight : this.scrollHeight;
      if (this.scrollHeight > 85) {
        this.isActive = true;
        this.showArrow = true;
      } else {
        this.showArrow = false;
      }
    },

    //tag展开收缩
    expand() {
      this.isActive = !this.isActive;
      this.showArrowDown = !this.showArrowDown;
      this.showArrow = !this.showArrow;
    },
    //distance
    distanceChange() {
      this.getHotelData();
    },
    //ResultSearch function
    getcityInfo(value) {
      if(window.name == '' || window.name == 'showmyiframe'){
        window.name = 'Result';
        this.centerPointHotelId = this.searchInfo.centerPointHotelId;
      }else{
        this.centerPointHotelId = '';
      }
      this.checkpaymentType(value.city.cityInfo);
      //清空支付类型、货币转换
      this.paymentType = "";
      this.currencyType.code = "";
      //设置loading
      this.keywordType = value.keywordType;
      this.wholeLoading = true;
      this.wholeLLoading = true;
      this.wholeHLoading = true;
      this.disabled_x = false;
      this.roomNum = value.roomNum;
      this.guestNum = value.guestNum;
      this.cityInfo = value.cityInfo;
      this.checkInDate = value.checkInDate;
      this.checkOutDate = value.checkOutDate;
      this.keyword = value.keyword;
      this.value = null;
      this.showstar = 3;
      this.show = 3;
      this.sortByPrice = null;
      this.sortByStarRating = null;
      this.isCityChange = value.isCityChange;
      if (!this.isBackFromDetail) {
        this.mapSearch = false;
        this.locationCode = "";
        if(!this.positionCityCode){
          this.address = "";
        }
        if (value.city) {
          if (value.keywordType == "input") {
            value.city.cityInfo.locationType = 0;
          }
          this.searchInfo.city = value.city;
          // 防止刷新出现无country
          if (value.city.cityInfo && value.city.cityInfo.countryCode) {
            this.objBaseInfo.countryCode = value.city.cityInfo.countryCode;
            this.objBaseInfo.isGATCity = isCityGAT(value.city.cityInfo.provinceCode);
            this.objBaseInfo.provinceCode = value.city.cityInfo.provinceCode;
            this.$forceUpdate();
          }
          this.updateSearchData();
          if (value.city.cityInfo.locationType != 0) {
            let locationInfo = {
              locationNameLists: value.city.cityInfo.locationName,
              longitude: value.city.cityInfo.locationLongitude,
              latitude: value.city.cityInfo.locationLatitude,
              geoCodeType: value.city.cityInfo.locationGeoCodeType,
              locationCode: value.city.cityInfo.locationCode,
            };
            switch (value.city.cityInfo.locationType) {
              case 1:
                this.clearHandle(false, "first", locationInfo);
                break;
              case 2:
                this.clearHandle(false, "second", locationInfo);
                break;
              case 3:
                this.clearHandle(false, "third", locationInfo);
                break;
              case 4:
                this.clearHandle(false, "four", locationInfo);
                break;
            }
          } else {
            if (this.objBaseInfo.channelId == "WEB") {
              this.clearHandle(true, this.activeName, {});
            } else {
              var activeName = this.$objBaseInfo.destinationType == "I"?"":"first";
              if(!this.positionCityCode){
                this.clearHandle(true, activeName, {});
              }
             
            }
          }
        } else {
          if (this.$objBaseInfo.channelId == "WEB") {
            this.clearHandle(true, this.activeName, {});
          } else {
            var activeName = this.$objBaseInfo.destinationType == "I"?"":"first";
            this.clearHandle(true, activeName, {});
          }
        }
      }
    },
    clearHandle(isClsoe, tabName, locationInfo) {
      if (this.objBaseInfo.channelId == "WEB") {
        this.haveAirports = false;
        this.haveCustoms = false;
        if (tabName == "second") {
          this.haveAirports = true;
        }
        if (tabName == "third") {
          this.haveCustoms = true;
        }
        this.tabName = tabName;
        this.activeName = tabName;
        this.locationAdd({ name: tabName });
        if (isClsoe) {
          this.handleClose();
        } else {
          this.addChosentags(locationInfo,false);
        }
      } else {
        switch (tabName) {
          case "first":
            this.treeActive = 0;
            this.areaRadio = locationInfo.locationCode;
            this.choseArea = locationInfo;
            this.distSelected = 5;
            break;
          case "second":
            this.treeActive = 1;
            this.waySelected = locationInfo.locationCode;
            this.choseWay = locationInfo;
            this.distSelected = 5;
            break;
          case "third":
            this.treeActive = 2;
            this.customSelected = locationInfo.locationCode;
            this.choseCustom = locationInfo;
            this.distSelected = 5;
            break;
          case "four":
            this.tabName = tabName;
            this.treeActive = 3;
            break;
          default:
            this.treeActive = 99;
            this.distSelected = 5;
        }
        this.onTreeConfirm(locationInfo);
      }
    },
    locationInfo(value) {
      this.wholeLLoading = false;
      this.wholeLoading = !(!this.wholeHLoading && !this.wholeLLoading);
      this.locationInformation = value;
      this.customlocationGet();
      this.airportGet();
      this.$nextTick(() => {
        this.height();
      });
    },
    hotelInfo(value) {
      // page: 4
      //接收home页跳转来的参数
      this.roomNum = this.searchInfo.roomCount;
      this.guestNum = this.searchInfo.guestCount;
      this.keyword = this.searchInfo.keyword;

      this.hotelList = value;
      this.bjtx_page = 1;
      this.bjtx_count = this.hotelList.totalNum;
      this.wholeHLoading = false;
      this.wholeLoading = !(!this.wholeHLoading && !this.wholeLLoading);
      this.disabled_x = true;
      this.noMoreData = ((this.hotelList ? this.hotelList.length : 0) == this.bjtx_count) ? true : false;
      this.disabled_x = !this.noMoreData;
      this.$nextTick(() => {
        this.height();
      });
    },

    toDetail: function (data) {
      // console.log(this.isClickBooked)
      // if (!this.isClickBooked) {
      //   this.isClickBooked = true;
      // } else {
      //   return false;
      // }
      if(data == undefined) return false;
      let localGeo = {latitude: "", longitude: ""};
      if (data.hotelDescriptiveInfo.location) {
        localGeo = data.hotelDescriptiveInfo.location.find(item => {
          if (item.geoType == "gps") {
            return item;
          }
        })
      }
      let tagData = data
      let params = {
        posCode: this.objBaseInfo.poscode,
        hotelCode: data.hotelDescriptiveInfo.id.toString(),
        checkInDate: formatDateTime(this.checkInDate ? this.checkInDate : this.searchInfo.checkInAt, "YYYY-MM-DD"),
        checkOutDate: formatDateTime(this.checkOutDate ? this.checkOutDate : this.searchInfo.checkOutAt, "YYYY-MM-DD"),
        noGuests: this.guestNum,
        noRooms: this.roomNum,
        bookingContactId: this.objBaseInfo.loginID,
        paymentType: "",//this.paymentType.toString(),
        source: this.objBaseInfo.sourceType, //请求来源OBT/CRM,供延时功能使用
        pageRequest: {
          page: 1,
          per_page: 10,
        },
        language: ["en-US", "zh-CN"],
        countryCode: this.objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.searchInfo.city.cityCode, //城市id
        groupCode:data.hotelDescriptiveInfo.group,
      };
      if(Object.prototype.hasOwnProperty.call(this.objBaseInfo,"openResource"))
      {
        if(this.objBaseInfo.openResource!=undefined && this.objBaseInfo.openResource!="" && this.objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.objBaseInfo.openResource);
        }
      }
      if (data.currencyCode) {
        this.$objBaseInfo.defaultCurrencyCode = data.currencyCode;
        this.$objBaseInfo.defaultCurrencySign = this.$currencySign[this.$objBaseInfo.defaultCurrencyCode];
      }
      tagData.unChoosen = false
      this.hotelCode = data.hotelDescriptiveInfo.id;
      this.chooseCode = this.cityInfo ? this.cityInfo : this.searchInfo.city.cityCode;
      this.checkIn = this.checkInDate ? this.checkInDate : this.searchInfo.checkInAt;
      this.checkOut = this.checkOutDate ? this.checkOutDate : this.searchInfo.checkOutAt;
      this.roomCount = this.roomNum ? this.roomNum : this.searchInfo.roomCount;
      this.guestCount = this.guestNum ? this.guestNum : this.searchInfo.guestCount;
      let detailParam = {
        paymentType: this.paymentType,
        checkInAt: this.checkIn,
        checkOutAt: this.checkOut,
        roomCount: this.roomCount,
        guestCount: this.guestCount,
        cwtCityCode: this.chooseCode,
        cwtCountryCode:this.$objBaseInfo.countryCode,
        hotelcode: this.hotelCode,
        isAp: data.isAgencyPreferredHotel,
        isCp: data.isClientPreferredHotel,
        latitude: localGeo.latitude.toString(),
        longitude: localGeo.longitude.toString(),
        currencyCode:this.currencyCode,
        sourceType: this.$objBaseInfo.sourceType,
        groupId:data.hotelDescriptiveInfo.group,
        cwtMark:data.hotelDescriptiveInfo.cwtMarkCode,
      };
      const tripOrderNo = this.objBaseInfo.tripOrderInfo?.triporderNo;
      if (tripOrderNo) {
        detailParam.searchParam = { tripApplyNo: tripOrderNo };
      }
      if (this.$objBaseInfo.channelId == "MOBILE") {
        sessionStorage.setItem("mapData", JSON.stringify(data));
        sessionStorage.setItem("resultData", JSON.stringify(this.$data));
      }
      if(this.$objBaseInfo.sourceType == "OBT" && this.$objBaseInfo.channelId == "WEB"){
        const queryString = new URLSearchParams(normalizeDetailQuery(detailParam)).toString();
        const detailPath = `${process.env.BASE_URL || "/"}Detail?${queryString}`;
        const safeUrl = getSafeDetailOpenUrl(detailPath);
        if (safeUrl) {
          const detailLink = document.createElement("a");
          detailLink.href = safeUrl;
          detailLink.target = "_blank";
          detailLink.rel = "noopener noreferrer";
          detailLink.referrerPolicy = "no-referrer";
          detailLink.click();
        }
      }else{
        let message = {};
        message.hotelId = data.hotelDescriptiveInfo.id;
        window.parent.postMessage(message, "*");
        this.$router.push({
          name: "Detail",
          query: normalizeDetailQuery(detailParam),
        });
      }
    },
    toMap: function () {
      this.chooseCode = this.cityInfo ? this.cityInfo : this.searchInfo.city.cityCode;
      this.checkIn = this.checkInDate ? this.checkInDate : this.searchInfo.checkInAt;
      this.checkOut = this.checkOutDate ? this.checkOutDate : this.searchInfo.checkOutAt;
      this.roomCount = this.roomNum ? this.roomNum : this.searchInfo.roomCount;
      this.guestCount = this.guestNum ? this.guestNum : this.searchInfo.guestCount;
      this.searchInfo.city.cityCode = this.chooseCode;
      let mapParam = {
        checkInAt: this.checkIn,
        checkOutAt: this.checkOut,
        roomCount: this.roomCount,
        guestCount: this.guestCount,
        cwtCityCode: this.chooseCode,
        city: this.searchInfo.city,
        keyword: this.keyword, //this.searchInfo.keyword,
        paymentType: this.paymentType,
        keywordType: this.keywordType,
        priceArea:this.priceArea,
        priceAreaValue:this.priceAreaValue,
        stars: this.starSelect,
        groupCode:this.hotelGroupSelect,
        showStar:this.showstar,
        showPrice:this.show,
        radius: this.value,
      };
      this.$router.push({
        name: "gaodeMap",
        query: { searchParam: JSON.stringify(mapParam), sourceType:this.objBaseInfo.sourceType },
      });
    },
    ptOpenDowOrUp: function (type) {
      if (this.canClick) {
        this.canClick = false;
        switch (type) {
          case "price":
            if (this.show == 3) {
              this.show = 1;
            } else if (this.show == 1) {
              this.show = 2;
            } else if (this.show == 2) {
              this.show = 1;
            }
            this.showstar = 3;
            this.sortByStarRating = null;
            // this.sortByPrice初始值null
            // this.sortByPrice == null ? true : !this.sortByPrice;
            this.sortByPrice = !this.sortByPrice;
            break;
          case "star":
            if (this.showstar == 3) {
              this.showstar = 1;
            } else if (this.showstar == 1) {
              this.showstar = 2;
            } else if (this.showstar == 2) {
              this.showstar = 1;
            }
            this.show = 3;
            // this.sortByPrice初始值null
            this.sortByPrice = null;
            // this.sortByStarRating == null ? true : !this.sortByStarRating;
            this.sortByStarRating = !this.sortByStarRating;
            break;
        }
        this.getHotelData();
      }
    },

    setPriceAffix: function () {
      let nodeList = document.querySelectorAll("span.hotel_list_price");
      if (nodeList != null && nodeList.length > 0) {
        for (const index in nodeList) {
          if (parseFloat(index).toString() != "NaN") {
            if (this.$i18n.locale === "en") {
              nodeList[index].setAttribute("data-content-after", "");
            } else {
              nodeList[index].setAttribute("data-content-before", "");
            }
          }
        }
      }
      let nodeList1 = document.querySelectorAll("div.hotel_list_price1");
      if (nodeList1 != null && nodeList1.length > 0) {
        for (const index in nodeList1) {
          if (parseFloat(index).toString() != "NaN") {
            if (this.$i18n.locale === "en") {
              nodeList1[index].setAttribute("data-content-after1", "");
            } else {
              nodeList1[index].setAttribute("data-content-before1", "");
            }
          }
        }
      }
      let nodeList2 = document.querySelectorAll("div.hotel_list_price2");
      if (nodeList2 != null && nodeList2.length > 0) {
        for (const index in nodeList2) {
          if (parseFloat(index).toString() != "NaN") {
            if (this.$i18n.locale === "en") {
              nodeList2[index].setAttribute("data-content-after2", "");
            } else {
              nodeList2[index].setAttribute("data-content-before2", "");
            }
          }
        }
      }
    },

    addChosentags(addlabel,isTab) {
      this.centerPointHotelId = '';
      this.isAddTags = true;
      this.showstar = 3;
      this.show = 3;
      this.sortByPrice = null;
      this.sortByStarRating = null;
      let label = addlabel.locationNameLists;
      this.labelLongitude = addlabel.longitude;
      this.labelLatitude = addlabel.latitude;
      this.geoCodeType = addlabel.geoCodeType;
      if (this.chosentags.length == 0) {
        if (this.tabName != "four") {
          this.chosentags.push(label);
        }
      } else {
        this.chosentags.splice(0, 1, label);
      }
      this.keywordInput = {keyword: label[this.$t("RESULT.RESPONSEDATA.locationNameLists")], keywordType: "auto"};
      this.keyword = "";
      this.locationCode = addlabel.locationCode;
      this.value = 5;
      if(isTab)
      {
        this.searchInfo.city.cityInfo.locationName = addlabel.locationNameLists;
        this.searchInfo.city.cityInfo.locationCnName = addlabel.locationName;
        this.searchInfo.city.cityInfo.locationCode = addlabel.locationCode;
        this.searchInfo.city.cityInfo.locationEnName = addlabel.locationNameLists.en;
        this.searchInfo.city.cityInfo.locationLatitude = addlabel.latitude;
        this.searchInfo.city.cityInfo.locationLongitude = addlabel.longitude;
        this.searchInfo.city.cityInfo.locationType = addlabel.locationType;
        this.keywordType = "auto";
        
      }
      this.getHotelData();
    },
    /**
     * @param {string} [queryType] - rolling:滚动查询;button:搜索按钮查询;不传参:其他查询
     */
    async getHotelData(queryType) {
      if (this.isExecuting) {
        return;
      }
      this.isExecuting = true;
      if (queryType !== "rolling") {
        this.bjtx_page = 1;
        this.wholeLoading = true;
        this.currencyCode = "";
        if(this.objBaseInfo.sourceType == "OBT" && queryType != "price" && !this.mapSearch){
          this.popUpAnnouncement(this.isCityChange);
          this.isCityChange = false;
          this.searchHotHotel();
        }
      } else {
        this.bjtx_page = this.bjtx_page + 1;
        this.loadingIsFloatingLayer = false; //控制Loading样式
        this.hotelloading = true;
      }
      this.originalStarSelect = this.starSelect;
      this.cwtCityCode = this.cityInfo ? this.cityInfo : this.searchInfo.city.cityCode;
      this.checkInDay = this.InDay = this.checkInDate ? this.checkInDate : this.searchInfo.checkInAt;
      this.checkOutDay = this.OutDay = this.checkOutDate ? this.checkOutDate : this.searchInfo.checkOutAt;
      this.radius = this.value ? this.value : null;
      let Hotelparams = {
        posCode: this.objBaseInfo.poscode,
        customerCode: this.objBaseInfo.customerCode,
        bookingContactId: this.objBaseInfo.loginID, //联系人ID
        countryCode: this.objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.cwtCityCode, //"310100"
        radius: this.radius,
        radiusUnit: this.radius ? "km" : null,
        checkInDate: formatDateTime(this.checkInDay, "YYYY-MM-DD"),
        checkOutDate: formatDateTime(this.checkOutDay, "YYYY-MM-DD"),
        noGuests: this.guestNum,
        noRooms: this.roomNum,
        sources: [],
        keyword: this.keywordType == "input" ? this.keyword?.trim() : "",
        SortByStarRating: this.sortByStarRating,
        SortByPrice: this.sortByPrice,
        pageRequest: {
          page: this.bjtx_page,
          per_page: this.showMapResult ? 30 : this.pageCount,
        },
        Language: ["en-US", "zh-CN"],
        PriceArea:this.priceArea,
        stars: this.starSelect,
        groupCode:this.hotelGroupSelect,
      };
      delete Hotelparams.cwtLocationCode;
      delete Hotelparams["coordinates"];
      if (this.tabName == "first" || this.tabName == "") {
        Hotelparams.cwtLocationCode = this.locationCode;
        // Hotelparams.radius = null;
        delete Hotelparams.radius;
        delete Hotelparams.radiusUnit;
        // if(this.keywordType == "auto"){
        //   delete Hotelparams.keyword;
        // }
      } else if(this.geoCodeType != ""){
        this.coordinates.longitude = this.labelLongitude;
        this.coordinates.latitude = this.labelLatitude;
        this.coordinates.geoType = this.geoCodeType;
        Hotelparams["coordinates"] = this.coordinates;
      }
      //payment change
      if (this.paymentType !== "") {
        Hotelparams.paymentMethod = this.paymentType;
      } else {
        delete Hotelparams.paymentMethod;
      }
      // if (this.chosentags.length == 0 || this.tabName == "four") {
      //   delete Hotelparams["coordinates"];
      //   delete Hotelparams.cwtLocationCode;
      //   delete Hotelparams.radius;
      //   delete Hotelparams.radiusUnit;
      // }
      if (this.objBaseInfo.destinationType == "I" && this.value) {
        Hotelparams.radius = this.value;
        Hotelparams.radiusUnit = "km";
      }
      if(Object.prototype.hasOwnProperty.call(this.objBaseInfo,"openResource"))
      {
        if(this.objBaseInfo.openResource!=undefined && this.objBaseInfo.openResource!="" && this.objBaseInfo.openResource!=null)
        {
          Hotelparams.openResource=JSON.parse(this.objBaseInfo.openResource);
        }
      }
      if(this.centerPointHotelId){
        Hotelparams.centerPointHotelId = this.centerPointHotelId;
        Hotelparams.radius = this.value,
        Hotelparams.radiusUnit = "km";
      }
      if(this.mapSearch){
        this.coordinates.longitude = this.labelLongitude;
        this.coordinates.latitude = this.labelLatitude;
        Hotelparams.radius = 5;
        Hotelparams.radiusUnit = "km";
        Hotelparams["coordinates"] = this.coordinates;
        if(queryType == 'clear'){
          delete Hotelparams["coordinates"];
          delete Hotelparams.cwtLocationCode;
          delete Hotelparams.radius;
          delete Hotelparams.radiusUnit;
        }
      }
      availabilityArea(Hotelparams)
        .then((res) => {
          this.isExecuting = false;
          this.isBackFromDetail = false;
          if (res.code == 200) {
            //获取当前请求返回的条数
            let currentNum = res.data.hotelList ? res.data.hotelList.length : 0;
            if (res.data.error.code === 0) {
              var newArr = res.data.hotelList;
              if(this.priceArea && this.priceArea.indexOf(",") > 0){
                
                newArr = [];
                var temp = this.priceArea.split(",")[1];
                for(var i = 0; i < res.data.hotelList.length;i++){
                  var hotelInfo = res.data.hotelList[i];
                  if(hotelInfo.averagePrice <= +(temp)){
                     newArr.push(hotelInfo);
                  }
                }
              }
              if (queryType !== "rolling") {
                this.hotelList = newArr;
                this.hotelList.map(item=>{
                  let currencyArr = item.convertedPrice
                  currencyArr.map(list=>{
                    if (list.currencyCode === "USD"){
                      item.usDollar = list.averagePrice;
                    } else if (list.currencyCode === "EUR") {
                       item.european = list.averagePrice;
                    } else if (list.currencyCode === "CNY") {
                      item.ChineseCNY = list.averagePrice;
                    }
                    return list;
                  })
                  return item;
                })
                this.bjtx_count = res.data.pagination.totalItemCount ? res.data.pagination.totalItemCount : 0;
              } else {
                this.hotelList = this.hotelList.concat(newArr ? newArr : []);
                this.hotelList.map(item=>{
                  let currencyArr = item.convertedPrice
                  currencyArr.map(list=>{
                    if (list.currencyCode === "USD"){
                      item.usDollar = list.averagePrice;
                    }
                    else if (list.currencyCode === "EUR") {
                       item.european = list.averagePrice;
                    }
                    else if (list.currencyCode === "CNY") {
                       item.ChineseCNY = list.averagePrice;

                    }
                    return list;
                  })
                  return item;
                })
              }
            } else { //返回空
              if (queryType !== "rolling") {
                this.hotelList = [];
                this.bjtx_count = 0;
                this.confirmIcon = "exclamation";
                this.confirmMsg = this.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? res.data.error.message : this.$t("ERRORMESSAGE." + res.data.error.code);
                this.confirmFlag = true;
              } else {
                //处理接口bug，本该有数据返回但接口返回空的情况
                if (currentNum === 0) {
                  this.bjtx_page = this.bjtx_page - 1;
                }
              }
              console.log("availabilityArea, code:" + res.data.error.code, res.data.error.message);
            }
            this.traceid = res?.data?.traceId ?? "";
            if (this.bjtx_count === 0) {
              this.noMoreData = true;
            } else {
              this.noMoreData = this.bjtx_count && (this.hotelList.length == this.bjtx_count ? true : false);
            }
            this.disabled_x = !this.noMoreData;
            this.canClick = true;
            //处理Loading
            if (queryType !== "rolling") {
              this.wholeHLoading = false;
              this.canClick = true;
              this.wholeLoading = !(!this.wholeHLoading && !this.wholeLLoading);
            } else {
              this.hotelloading = false;
              this.canClick = true;
            }
          } else {
            this.hotelloading = false;
            this.wholeHLoading = false;
            this.wholeLLoading = false;
            this.wholeLoading = false;
            this.disabled_x = true;
            this.canClick = true;
            this.confirmFlag = true;
            this.confirmMsg = this.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? this.$t("ERRORMESSAGE.NOTFOUND") : this.$t("ERRORMESSAGE." + res.code);
          }
        })
        .catch(function (e) {
          this.hotelloading = false;
          this.wholeHLoading = false;
          this.wholeLLoading = false;
          this.wholeLoading = false;
          this.disabled_x = true;
          this.canClick = true;
          this.confirmFlag = true;
          this.confirmMsg = this.$t("ERRORMESSAGE." + e.mesCode);

        });
    },
    async getLocationData(type) {
      let that = this;
      this.loading = true;
      try {
        this.chooseCode = this.cityInfo ? this.cityInfo : this.searchInfo.city.cityCode;
        let params = { params: { CityCode: this.chooseCode, LocationType: type, isEnable: 1 } };
        if (this.tabName == 'third' || type == 3) {
          params.params.customerCode = this.objBaseInfo.customerCode;
        }
        const res = await locationList(params);
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            if (type == 2) {
              this.haveAirports = true;
              if (this.objBaseInfo.destinationType == "I") {
                this.activeName = "second";
              }
              this.airportslocationInfo = res.data.list;
            }
            if (type == 3) {
              this.haveCustoms = true;
              if (this.objBaseInfo.destinationType == "I") {
                this.activeName = "third";
              }
              this.customlocationInfo = res.data.list;
            }
          } else {
            if (type == 2) {
              this.haveAirports = false;
              this.airportslocationInfo = [];
            }
            if (type == 3) {
              this.haveCustoms = false;
              this.customlocationInfo = [];
            }
          }
          this.loading = false;
          this.$nextTick(() => {
            this.height();
          });
          if (res.data.error.code != 0) {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.data.error.code);
          }
        } else {
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.code);
        }

      } catch (e) {
        that.confirmFlag = true;
        that.confirmMsg = that.$t("ERRORMESSAGE.500");
        console.log("try-catch", e);
      }
    },

    locationAdd(tab) {
      this.tabName = tab.name;
      if (this.tabName === "second") {
        this.showArrowDown = false;
        this.paneHeight = "pane-second";
        this.locationType = 2;
        this.showDistance = true;
      } else if (this.tabName === "third") {
        this.showArrowDown = false;
        this.paneHeight = "pane-third";
        this.locationType = 3;
        this.showDistance = true;
      } else {
        this.locationType = 1;
        this.showArrowDown = false;
        this.showDistance = false;
        this.paneHeight = "pane-first";
      }
      this.$nextTick(() => {
        this.height();
      });
    },
    handleClose(tag) {
      this.isAddTags = false;
      this.deleteTag = tag;
      this.chosentags.splice(this.chosentags.indexOf(tag), 1);
      this.value = this.centerPointHotelId? 3: this.value;
      this.keywordInput = {keyword: this.keyword, keywordType: "input"};
      if (tag === undefined) { //点击搜索按钮
        this.getHotelData("button");
      } else {
        this.searchInfo.city.cityInfo.locationName = "";
        this.searchInfo.city.cityInfo.locationCnName = "";
        this.searchInfo.city.cityInfo.locationCode = "";
        this.searchInfo.city.cityInfo.locationEnName = "";
        this.searchInfo.city.cityInfo.locationLatitude = "";
        this.searchInfo.city.cityInfo.locationLongitude = "";
        this.searchInfo.city.cityInfo.locationType = "";
        this.locationCode = "";
        this.geoCodeType = "";
        this.value = null;
        this.radiusUnit = "";
        this.keywordType = "input";
        this.getHotelData();
      }
    },

    handleScroll() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      //变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // console.log("滚动距离：", scrollHeight - scrollTop - windowHeight);
      let distance = 5; //PC端触发加载的距离阈值
      if (this.objBaseInfo.channelId === "MOBILE") distance = 80; //移动端触发加载的距离阈值
      //滚动条到底部的条件
      if (scrollHeight - scrollTop - windowHeight <= distance && this.disabled_x) { // && this.list.length !== 0
        this.disabled_x = false;
        this.hotelloading = true;
        this.loadingIsFloatingLayer = false;
        let timer = setTimeout(() => {
          this.getHotelData("rolling"); // 加载的列表数据
          timer = null;
          clearTimeout(timer);
        }, 1000);
      }
    },
    handlePaymentChange() {
      //入参添加字段paymentType，string，传值为: 0=只看前台现付/1=只看公付
      this.getHotelData();
    },
    handleStarChange(visible){
      if (!visible) {
        if(JSON.stringify(this.starSelect) != JSON.stringify(this.originalStarSelect)){
          this.getHotelData();
        }
      }
    },
    // 切换货币
    handleCurrencyChange(data){
      this.currencyCode = data
      console.log(data,'切换货币');
    },
    
    handlePriceRangeChange(type){
      
      switch (type) {
        case 2:
          this.priceArea = "0,300";
          break;
        case 3:
          this.priceArea = "300,500";
          break;
        case 4:
          this.priceArea = "500,1000";
          break;
        case 5:
          this.priceArea = "1000";
          break;
        case 6:
          this.showCustomizePriceRange = true;
          break;
        default:
          this.priceArea = "";
          break;
      }
      if(type!=6){
        this.getHotelData("price");
      }
    },
    clearNoNumPriceRangeFrom(){
      this.priceRangeFrom = this.priceRangeFrom.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.priceRangeFrom = this.priceRangeFrom.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.priceRangeFrom = this.priceRangeFrom.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.priceRangeFrom = this.priceRangeFrom.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.priceRangeFrom = this.priceRangeFrom.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.priceRangeFrom.indexOf(".") < 0 && this.priceRangeFrom != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.priceRangeFrom = parseFloat(this.priceRangeFrom);
      }
    },
    clearNoNumPriceRangeTo(){
      this.priceRangeTo = this.priceRangeTo.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      this.priceRangeTo = this.priceRangeTo.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      this.priceRangeTo = this.priceRangeTo.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      this.priceRangeTo = this.priceRangeTo.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
      this.priceRangeTo = this.priceRangeTo.replace(/^0+\./g, '0.').replace(/^0+([0-9])/, '$1');  //清除.前面无效的0
      if (this.priceRangeTo.indexOf(".") < 0 && this.priceRangeTo != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.priceRangeTo = parseFloat(this.priceRangeTo);
      }
    },
    searchHotelForPriceRange(){
      if (this.priceRangeTo != "" && this.priceRangeFrom != ""){
        this.priceArea = this.priceRangeFrom + "," + this.priceRangeTo;
        this.priceAreaValue = this.priceArea.replace(",", "-");
        this.priceRangeTitle = this.priceArea.replace(",", "-");
      } else if (this.priceRangeTo == "" && this.priceRangeFrom == ""){
        this.priceArea = "";
        this.priceAreaValue = this.priceArea;
        this.priceRangeTitle = this.priceArea;
      }else if (this.priceRangeTo == ""){
        this.priceArea = this.priceRangeFrom.toString();
        this.priceAreaValue = this.$t("RESULT.PRICERANGE7", {
          priceRange: this.priceArea,
          });
        this.priceRangeTitle = this.$t("RESULT.PRICERANGE7", {
          priceRange: this.priceArea,
          });
      }else{
        this.priceArea =  "0," + this.priceRangeTo;
        this.priceAreaValue = this.priceArea.replace(",", "-");
        this.priceRangeTitle = this.priceArea.replace(",", "-");
      }
      
      this.showCustomizePriceRange = false;
      this.getHotelData();
    },
    priceRangeClose(newVal){
      
      if(newVal == 6 && !this.showCustomizePriceRange){
        this.showCustomizePriceRange = true;
      }
      
    },
    // ptOpenCustomizePrice(){
    //   alert(111);
    // },
    searchAnnouncementInfo(val){
      var cityInfo = this.searchInfo.city;
      let announcementParams = {
        params: {
          customerCode: this.objBaseInfo.customerCode,
          cityCode: cityInfo.cityCode,
          cityName:decodeURI(cityInfo.cityName),
          countryCode:cityInfo.cityInfo.countryCode,
          posCode:this.objBaseInfo.poscode,
          channelID: this.objBaseInfo.channelId,
          lang:this.$i18n.locale == "en"? this.$i18n.locale : "zh-CN"
        },
      };
      getAnnouncementInfo(announcementParams)
        .then((res) => {
          if (res.code == 200) {
            if(val == 1){
              this.hotelListNoticeDialogVisible = true;
            }
            this.objBaseInfo.announcementNotice = res.data.notice;
            if(res.data.isNavigationBarLabel){
              if (this.$i18n.locale == "en"){
                this.noticeTitle = res.data.title["en"];
              }else{
                this.noticeTitle = res.data.title["zh-CN"];
              }
              this.showHotelListNotice = true;
            }else{
              this.showHotelListNotice = false;
            }
          }
        })
        .catch((err) => {
        });
    },
    //Announcement
    setAnnouncementFlag(value) {
      this.hotelListNoticeDialogVisible = value;
    },
    searchHotHotel(){
      var cityInfo = this.searchInfo.city;
      let hotHotelParams = {
        params: {
          cityCode: cityInfo.cityCode,
        },
      };
      gethothotel(hotHotelParams)
        .then((res) => {
          if (res.code == 200) {
            if(res.data && res.data.hotHotelList.length > 0){
              this.hotHotelInfo = res.data.hotHotelList;
              this.showHotHotel = true;
            }else{
              this.showHotHotel = false;
            }
          }else{
            this.showHotHotel = false;
          }
        })
        .catch((err) => {
          this.showHotHotel = false;
        });
    },
    choseHotHotel(val){
      
      this.keyword = val.hotelName[this.$t('RESULT.RESPONSEDATA.locationNameLists')];
      this.keywordInput = {keyword: this.keyword, keywordType: "input"};
      this.getHotelData();
    },
    popUpAnnouncement(showDialog){
      var uiAnnoucementSettings = this.objBaseInfo.uiAnnoucementSettings;
      if(uiAnnoucementSettings && uiAnnoucementSettings.length> 0){
        if(uiAnnoucementSettings[0].isPopUp && showDialog){
          sessionStorage.setItem("isFirstIntoResult", false);
          this.searchAnnouncementInfo(1);
        }else if(uiAnnoucementSettings[0].isNavigationBarLabel){
          this.searchAnnouncementInfo();
          if (this.$i18n.locale == "en"){
            this.noticeTitle = uiAnnoucementSettings[0].title["en"];
          }else{
            this.noticeTitle = uiAnnoucementSettings[0].title["zh-CN"];
          }
          this.showHotelListNotice = true;
        }else{
          this.showHotelListNotice = false;
        }
      }
    },
    checkpaymentType(cityInfo){
      if(this.objBaseInfo.openResource){
        var data = JSON.parse(this.objBaseInfo.openResource);
        this.isCorpPay = false;
        this.isHotelPay = false;
        this.isPrepay = false;
        if(this.objBaseInfo.destinationType === "I" && data.International.includes("3")){//国际是否开启公付
          this.isCorpPay = true;
        }else if (this.objBaseInfo.destinationType === "I" && data.International.includes("1")){//国际是否开启现付
          this.isHotelPay = true;
        }else if (this.objBaseInfo.destinationType === "I" && data.International.includes("2")){//国际是否开启预付
          this.isPrepay = true;
        }
        if (cityInfo && cityInfo != {} && this.objBaseInfo.destinationType === "D") {
          if(isCityGAT(cityInfo.provinceCode)){
            if(data.GangAoTai.includes("3")){//港澳台是否开启公付
              this.isCorpPay = true;
            }
            if(data.GangAoTai.includes("1")){//港澳台是否开启现付
              this.isHotelPay = true;
            }
            if(data.GangAoTai.includes("2")){//港澳台是否开启预付
              this.isPrepay = true;
            }
          }else{
            if(data.Domestic.includes("3")){//大陆是否开启公付
              this.isCorpPay = true;
            }
            if(data.Domestic.includes("1")){//大陆是否开启现付
              this.isHotelPay = true;
            }
            if(data.Domestic.includes("2")){//大陆是否开启预付
              this.isPrepay = true;
            }
          }
        } 
      }
    },
    updateSearchData() {
      if (this.searchInfo.priceArea) {
        [this.priceArea, this.searchInfo.priceArea] = [this.searchInfo.priceArea, ''];
        this.priceAreaValue = this.searchInfo.priceAreaValue;
      }
      if (this.searchInfo.stars) {
        [this.starSelect, this.searchInfo.stars] = [this.searchInfo.stars, ''];
        this.originalStarSelect = this.stars;
      }
      if (this.searchInfo.groupCode) {
        [this.hotelGroupSelect, this.searchInfo.groupCode] = [this.searchInfo.groupCode, ''];
      }
      if (this.searchInfo.paymentType) {
        [this.paymentType, this.searchInfo.paymentType] = [this.searchInfo.paymentType, ''];
      }
      if (this.searchInfo.showStar && this.searchInfo.showStar != 3) {
        [this.showstar, this.searchInfo.showStar] = [this.searchInfo.showStar, ''];
        this.sortByPrice = null;
        this.sortByStarRating = !this.sortByStarRating;
      }
      if (this.searchInfo.showPrice && this.searchInfo.showPrice != 3) {
        [this.show, this.searchInfo.showPrice] = [this.searchInfo.showPrice, ''];
        this.sortByStarRating = null;
        this.sortByPrice = !this.sortByPrice;
      }
      if (this.searchInfo.radius) {
        [this.value, this.searchInfo.radius] = [this.searchInfo.radius, ''];
      }else{
        this.value = 30;
      }
    },
  },
};
</script>
<style>
@media screen and (max-width: 320px) {
  .list-img {
    height: 35rem !important;
  }
  .hotel_bigfont{
    width: 53rem !important;
  }
    .content_img {
      width: 30%;
    }
  .policy_outof_in {
    width: 25rem !important;
  }
  .list_agree {
    margin-top: 11rem !important;
  }
  .list-content-star {
    width: 2rem !important;
    height: 2rem !important;
  }
  .dialog-footer {
    padding: 0px;
  }
}
@media screen and (min-width: 350px) and (max-width: 405px) {
  #search_area #main {
    margin-left: -5rem;
  }
}
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  /* 位置距离标题 */
  /* .location_active {
    color: #409eff;
    font-weight: bold;
  } */
  .location_active{
    position: relative;
  }

  .location_active::before{
    content: "";
    border: 3px solid red;
    border-radius: 3px;
    position: absolute;
    z-index: 1000;
    left: 2rem;
    bottom: 2.6rem;
  }

  .content_page_height {
    padding: 0;
    min-height: 100vh;
  }
  .top-vant-btn {
    width: 45%;
    float: left;
    margin: 1rem;
  }
  .map_btn{
    text-align: center;
    line-height: 4rem;;
    position: fixed;
    top: 92%;
    left: 40%;
    height: 4rem;
    width: 10rem;
    z-index: 99;
  }
  .bg-purple-light {
    padding-left: 1rem;
    height: 30rem;
  }
  svg.list-content-star.svg-icon {
    width: 1.4rem;
    height: 1.4rem;
    margin-top: 1rem;
  }
  .list-content-tel {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .grid-content.bg-purple.list-content-preferred {
    /* text-align: right; */
    min-width: 10rem;
    margin-top: 1rem;
  }
  .van-sidebar-item__text {
    word-break: inherit;
  }
  .content_img {
    width: 15rem;
    height: 26rem;
  }
  .policy_outof_in {
    width: 12rem !important;
  }

  /* .list_agree {
    margin-top: 8rem;
    width: 25%;
    margin-right: 1rem;
  } */

  .list_hotel {
    width: 40%;
  }
  .list_hotel_content {
    min-height: 19rem;
    display: grid;
  }
  .list-img {
    height: 24rem;
  }

  .sort_nav {
    width: 25%;
  }

  /* .hotel_container_panel {
    padding: 0;
  } */

  .btn_book {
    float: right;
  }
  .content_size1::-webkit-scrollbar {
    width: 0.1rem;
    color: black;
  }

  .tag_height {
    height: 7.5rem;
    transition: min-height 2s linear;
    -webkit-transition: height 2s linear;
    overflow: hidden;
  }

  .icon_tags {
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom: 1rem;
    height: 3rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    color: #333f48 !important;
    border-radius: 0;
    background-color: #e7e9ea !important;
  }

  .tag_sty {
    height: 3rem !important;
    border-radius: 1.8rem !important;
    border: 0.1rem solid #333f48 !important;
    margin-left: 1rem !important;
    color: #333f48 !important;
  }

  /*去掉el-tab-pane底部灰色线条*/
  .deleteBorder .el-tabs__nav-wrap::after {
    height: 0;
  }

  .fontstyle {
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
    margin-left: 10px;
  }

  .location_area_bg {
    margin-top: 1rem;
    background-color: white;
    margin-left: 0;
    margin-right: 0;
  }

  .homeMain .el-tabs__item {
    line-height: 2rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    font-weight: 600;
    color: #333f48;
  }

  .payment .el-input {
    width: 18rem;
    font-size: 1.4rem;
  }

  .el-breadcrumb__inner {
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
  }
  .el-breadcrumb {
    display: none;
  }

  .el-input__inner {
    height: 3rem;
  }

  .el-input__icon {
    line-height: 0;
  }

  .above_chinese {
    float: right;
    margin-top: 1.5rem;
  }

  .hotel_list_price {
    font-size: 1.8rem;
  }

  .hotel_list_price::after {
    content: attr(data-content-after);
    font-size: 1.5rem;
    margin-right: 0.5rem;
    color: #39393a;
  }

  .hotel_list_price::before {
    content: attr(data-content-before);
    font-size: 1.5rem;
    margin-left: -1rem;
    color: #39393a;
  }
  .hotel_list_price1 {
    font-size: 1vw;
    margin-right: -0.4rem;
    margin-left: 4rem;
  }

  .hotel_list_price1::after {
    content: attr(data-content-after1);
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }

  .hotel_list_price1::before {
    content: attr(data-content-before1);
    font-size: 1.5rem;
    margin-left: -1rem;
  }
  .hotel_price {
    /* margin-top: 1.5rem; */
  }
  .hotel_list_price2{
    font-size: 1.1rem;
    /* margin-right: -0.4rem; */
    margin-left: -6.5rem;
    text-align: right;
  }
  /* .hotel_list_price2::after {
    content: attr(data-content-after2);
    font-size: 1.1rem;
    margin-right: 0.5rem;
  }
  .hotel_list_price2::before {
    content: attr(data-content-before2);
    font-size: 1.1rem;
    margin-left: -1rem;
  } */

  .red_color {
    color: red;
  }

  #search_area #main {
    text-align: right;
    width: 25rem;
  }

  .checkava {
    font-size: 1vw !important;
  }

  .showmore_content {
    /*margin-top: 2.1rem;*/
    margin-bottom: 4.2rem;
    background-color: #e7e9ea;
    height: 3rem;
  }

  .showmore_font {
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    cursor: pointer;
    color: #1061cc;
    line-height: 2rem;
  }

  .showmore_font:hover {
    color: #0a3d80;
  }

  .nomore_font {
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    line-height: 2rem;
  }

  .checkava_btn {
    font-size: 1vw;
    width: 13vw;
    height: 6vh;
    background-color: #fc6640;
    margin-left: 10%;
    border-radius: 0rem;
  }

  .checkava_btn:hover {
    background-color: #e65e43;
  }

  .checkava_btn:focus {
    background-color: #c83516;
  }

  .policy_svg {
    /* margin-top: 2rem !important; */
    margin-right: -1rem !important;
    float: right;
    /*width: 9vw*/
  }

  .content_bg {
    margin-top: 1rem;
    background-color: white;
    padding: 1rem;
    display: flex;
    align-items: center;
  }

  .showmap_icon_style {
    width: 2.4rem !important;
    height: 2.4rem !important;
    color: #1061cc !important;
  }

  .showmap {
    width: 9.2rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #1061cc;
    line-height: 2rem;
    cursor: pointer;
    white-space: nowrap;
  }

  .showmap:hover {
    color: #0a3d80;
  }

  .contact_font {
    min-width: 7rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #f2a900;
  }

  .commen_font {
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    font-weight: 600;
    color: #333f48;
    line-height: 2rem;
    cursor: pointer;
  }

  .commen_font:hover {
    color: #0a3d80;
  }

  .hotel_midfont {
    font-size: 1.4rem;
    font-family: sans-serif;
    color: #333f48;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
  }

  .hotel_bigfont {
    font-size: 1.8rem;
    font-family: sans-serif;
    color: #333f48;
    cursor: pointer;
    /* 多行 省略号 */
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .list_policy {
    border-radius: 6px;
    text-align: center;
    width: auto;
    float: right;
  }
  .list_price {
    /* margin-top: -2.5rem; */
    width: 25%;
  }

  /* #main {
    margin-top: 4.5rem;
  } */

  #bottom {
    height: 33.33%;
    display: none;
    /*float: right;*/
  }

  #sec_bottom {
    /*height: 33.33%;*/
    /* display: none; */
  }

  #sec_main {
    /* margin-top: 1rem; */
    width: 55%;
  }

  .center_style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content_size {
    margin-left: 0;
    margin-right: 0;
  }

  .content_size1 {
    /* position: relative; */
    margin-left: 0;
    margin-right: 0;
    overflow: hidden;
  }

  .hotel_content_size {
    margin-left: 4rem;
    margin-right: 2rem;
  }

  .grid-content {
    min-height: 5rem;
  }

  .van-radio__icon .van-icon {
    border: 0px;
  }

  .van-tag--primary.van-tag--plain {
    margin: 1rem;
    /* width: max-content; */
    /* max-width: 10rem; */
    padding: 1rem 2rem;
    font-size: 1.4rem;
    background: #eeeeee;
    color: #39393a;
  }
  .dist-title {
    margin-left: 1rem;
    font-size: 1.6rem;
    color: gray;
  }
  .van-tag--plain::before {
    border: 0px;
  }
  .click-dist-tag {
    background: #409eff !important;
    color: white !important;
  }
  .van-tree-select__content {
    -webkit-box-flex: 3;
    flex: 3;
  }
  .van-sidebar-item {
    font-size: 1.5rem;
  }
  .van-dropdown-menu__title,
  .van-cell {
    font-size: 1.6rem;
  }
  .van-calendar__day {
    height: 6rem;
    font-size: 1.2rem;
  }
  .van-calendar__bottom-info, .van-calendar__top-info {
    font-size: 1rem;
    line-height: 1.2rem;
  }
  .dialog-footer {
    padding: 0px;
  }
  .el-dialog{
    width: 80%;
  }
  .vant-announcement{
    padding: 0px!important;
    margin-bottom: 0px!important;
    color: #1989fa!important;
  }
  .travelRule{
    width: 16em;
    height: 3rem;
	  background-color:#FF694B;
    border-radius: 4px;
  }
  .travelRule .butt{
    width: 90%;
		height:2rem;
    height: calc(30% - 1px);
    text-align: center;
    margin: 0 auto;
    position: relative;
		line-height:3rem;
    /* background-color:#FF694B; */
		color:white;
  }
  .travelRule .butt::before{
    background-color: #f1f3f5;
    content: '';
    width: 0.5rem;
    height: 0.8rem;
    border-radius: 0 20px 20px 0;
    position: absolute;
    left: -1.3rem;
    top: 1rem;
   }
	.travelRule .butt::after{
		background-color:#f1f3f5;
    content: '';
    width: 0.5rem;
    height: 0.8rem;
    position: absolute;
    border-radius:20px 0px 0px 20px;
    left: 20.9rem;
    top: 1rem;
  }
  .div_grid{
    display: grid;
    grid-template-columns: 0.1fr 1fr;
    align-items: center;
    padding:0.3rem 0;
    font-size: 13px;
  }
  .scrollable-dropdown {
    display: flex;
    overflow-x: auto; /* 允许水平滚动 */
    white-space: nowrap; /* 防止换行，所有项在一行 */
  }

  .scrollable-dropdown::-webkit-scrollbar {
    display: none; /* 隐藏滚动条（可选） */
  }
}
/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .content_page_height {
    padding: 0;
    min-height: 580px;
  }
  .bg-purple-light {
    padding-left: 1.3rem;
  }
  svg.list-content-star.svg-icon {
    width: 1.4rem;
    height: 1.4rem;
    margin-top: 1rem;
  }

  .list_agree {
    justify-content: center;
    align-items: center;
    display: flex;
    padding-top: 2.5rem
  }

  .list_hotel_content{
    height: 22rem;
  }

  .list-img {
    height: 22.7rem;
  }

  .btn_book {
    float: right;
  }
  .content_size1::-webkit-scrollbar {
    width: 0.1rem;
    color: black;
  }

  .tag_height {
    height: 7.5rem;
    transition: min-height 2s linear;
    -webkit-transition: height 2s linear;
    overflow: hidden;
  }

  .icon_tags {
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom: 1rem;
    height: 3rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    color: #333f48 !important;
    border-radius: 0;
    background-color: #e7e9ea !important;
  }

  .tag_sty {
    height: 3rem !important;
    border-radius: 1.8rem !important;
    border: 0.1rem solid #333f48 !important;
    margin-left: 1rem !important;
    color: #333f48 !important;
  }

  /*去掉el-tab-pane底部灰色线条*/
  .deleteBorder .el-tabs__nav-wrap::after {
    height: 0;
  }

  .fontstyle {
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
    margin-left: 10px;
  }

  .location_area_bg {
    margin-top: 1rem;
    background-color: white;
    margin-left: 0;
    margin-right: 0;
  }

  .homeMain .el-tabs__item {
    line-height: 2rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    font-weight: 600;
    color: #333f48;
  }

  .payment .el-input {
    width: 12rem;
    font-size: 1.4rem;
  }

  .payment-price-range {
    width: 100%;
    min-width: 15rem;
  }

  .payment-price-range :deep(.el-input),
  .payment-price-range :deep(.el-select__wrapper) {
    width: 100%;
    min-width: 15rem;
  }

  .payment-hotel-group {
    width: 100%;
    min-width: 15rem;
  }

  .payment-hotel-group :deep(.el-input),
  .payment-hotel-group :deep(.el-select__wrapper) {
    width: 100%;
    min-width: 15rem;
  }

  .payment-type {
    width: 100%;
    min-width: 14rem;
  }

  .payment-type :deep(.el-input),
  .payment-type :deep(.el-select__wrapper) {
    width: 100%;
    min-width: 14rem;
  }

  .payment-currency {
    width: 13rem;
    min-width: 13rem;
  }

  .payment-currency :deep(.el-input),
  .payment-currency :deep(.el-select__wrapper) {
    width: 100%;
    min-width: 13rem;
  }

  .payment-star,
  .payment-distance {
    width: 13rem;
    min-width: 13rem;
  }

  .payment-star :deep(.el-input),
  .payment-star :deep(.el-select__wrapper),
  .payment-distance :deep(.el-input),
  .payment-distance :deep(.el-select__wrapper) {
    width: 100%;
    min-width: 13rem;
  }

  .el-breadcrumb__inner {
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
  }

  .el-input__inner {
    height: 3rem;
  }

  .el-input__icon {
    line-height: 0;
  }

  .above_chinese {
    float: right;
    margin-top: 1.5rem;
  }

  .hotel_list_price {
    font-size: 3rem;
    font-weight: 600;
    margin-right: -0.4rem;
    margin-left: -1rem;
  }

  .hotel_list_price::after {
    content: attr(data-content-after);
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }

  .hotel_list_price::before {
    content: attr(data-content-before);
    font-size: 1.5rem;
    margin-left: -1rem;
  }
  .hotel_list_price1 {
    font-size: 0.8vw;
    margin-right: -0.4rem;
    margin-left: 4rem;
  }

  .hotel_list_price1::after {
    content: attr(data-content-after1);
    font-size: 1rem;
    margin-right: 0.5rem;
  }

  .hotel_list_price1::before {
    content: attr(data-content-before1);
    font-size: 1rem;
    margin-left: -1rem;
  }
  .hotel_price {
    margin-right: 2rem;
    margin-top: 2rem;
    text-align: right;
  }
  .hotel_list_price2{
    font-size: 1.3rem;
    margin-right: -0.4rem;
    margin-left: 4rem;
  }
  .hotel_list_price2::after {
    content: attr(data-content-after2);
    font-size: 1rem;
    margin-right: 0.5rem;
  }
    .hotel_list_price2::before {
    content: attr(data-content-before2);
  font-size: 1rem;
    margin-left: -1rem;
  }
  .red_color {
    color: red;
  }

  #search_area {
    float: right;
  }

  .checkava {
    font-size: 1vw !important;
  }

  .showmore_content {
    /*margin-top: 2.1rem;*/
    margin-bottom: 4.2rem;
    background-color: #e7e9ea;
    height: 3rem;
  }

  .showmore_font {
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    cursor: pointer;
    color: #1061cc;
    line-height: 2rem;
  }

  .showmore_font:hover {
    color: #0a3d80;
  }

  .nomore_font {
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    line-height: 2rem;
  }

  .checkava_btn {
    font-size: 1vw;
    width: 13vw;
    height: 6vh;
    background-color: #fc6640;
    margin-left: 10%;
    border-radius: 0rem;
  }

  .checkava_btn:hover {
    background-color: #e65e43;
  }

  .checkava_btn:focus {
    background-color: #c83516;
  }

  .policy_svg {
    margin-top: 2rem !important;
    margin-right: 0 !important;
    float: right;
    /*width: 9vw*/
  }

  .content_bg {
    margin-top: 1rem;
    background-color: white;
  }

  .showmap_icon_style {
    width: 2.4rem !important;
    height: 2.4rem !important;
    color: #1061cc !important;
  }

  .showmap {
    width: 9.2rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #1061cc;
    line-height: 2rem;
    cursor: pointer;
    white-space: nowrap;
  }

  .showmap:hover {
    color: #0a3d80;
  }

  .contact_font {
    width: 16.5rem;
    height: 2rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #f2a900;
  }

  .commen_font {
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    font-weight: 600;
    color: #333f48;
    line-height: 2rem;
    cursor: pointer;
  }

  .commen_font:hover {
    color: #0a3d80;
  }

  .hotel_midfont {
    /*width: 14.3rem;*/
    height: 2rem;
    font-size: 1.4rem;
    font-family: Sources Sans Pro;
    /* font-weight: bold; */
    color: #838A90;
  }

  .hotel_bigfont {
    padding-top: 1.8rem;
    width: 100%;
    /*height: 2.5rem;*/
    font-size: 1.8rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
    line-height: 2.5rem;
    cursor: pointer;
  }

  .list_policy {
    height: 8rem;
    margin-right: 2rem;
  }

  #main {
    height: 33.33%;
    /* float: right; */
    text-align: right;
    margin-right: 2rem;
    margin-bottom: -15px;
    margin-top: 25px;
  }

  #bottom {
    height: 33.33%;
    /*float: right;*/
  }

  #sec_bottom {
    height: 33.33%;
  }

  #sec_main {
    height: 33.33%;
    margin-top: 2.5rem;
  }

  #sec_top {
    height: 45%;
  }

  .center_style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content_size {
    margin-left: 6rem !important;
    margin-right: 5rem !important;
  }

  .content_size1 {
    /* position: relative; */
    margin-left: 6rem !important;
    margin-right: 5rem !important;
    overflow-x: auto;
    flex-wrap: nowrap;
  }

  .content_size1 > .el-col {
    flex-shrink: 0;
  }

  .hotel_content_size {
    margin-left: 4rem;
    margin-right: 2rem;
  }

  .grid-content {
    min-height: 5rem;
  }
  .customWidth{
    width: 20%;
    margin-top:40vh!important;
  }
}
</style>
